<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_update_mac_loc"></Header>
    <v-container fluid v-if="userMenu">
      <v-layout row wrap justify-center>
        <v-flex v-if="userLatLng">
          <v-layout row wrap>
            <v-flex md8>
              <v-btn class="mt-0" @click="findLocation">
                {{ "lng_update_map_lookup" | translate }}
              </v-btn>
              <v-btn
                :loading="locLoading"
                :disabled="locLoading"
                color="rgb(84,110,122)"
                class="mt-0 white--text"
                @click="updateLocation"
                >{{ "lng_update_map_save" | translate }}</v-btn
              >
            </v-flex>
            <v-flex md4>
              <h3 class="md-headline">{{ "lng_user_address" | translate }}:</h3>
              <p v-if="userLatLng.results[0]">
                {{ "lng_user_address" | translate }}:
                {{ userLatLng.results[0].formatted_address }}
                <br />
                {{ "lng_update_map_location" | translate }}: ({{
                  userLatLng.results[0].geometry.location.lat
                }}, {{ userLatLng.results[0].geometry.location.lng }})
              </p>
            </v-flex>
          </v-layout>
          <!-- <div class="google-map" id="map_canvas"></div> -->
          <gmap-map
            :center="marker"
            :zoom="12"
            style="width:100%;  height: 400px;"
          >
            <gmap-marker
              :position="marker"
              :clickable="true"
              :draggable="true"
              @dragend="getDraggedLoc"
            ></gmap-marker>
          </gmap-map>
        </v-flex>
      </v-layout>
    </v-container>
    <tech-access-dialog
      :messageText="msgText"
      :openDialog="techDialog"
      :closeDialog="closeTechDialog"
      :giveAccess="closeTechDialog"
    ></tech-access-dialog>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import TechAccessDialog from "../components/TechAccessDialog";
import router from "../router.js";

export default {
  components: {
    Header,
    TechAccessDialog
  },
  data: () => ({
    userMenu: undefined,
    userLatLng: undefined,
    marker: {},
    locLoading: false,
    newPosition: {},
    msgText: "lng_test",
    techDialog: false
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    var element = document.getElementsByTagName("body");
    window.scrollTo(0, element.offsetTop);
    // document.getElementsByTagName("html")[0].className = "";
    // console.log("ggggg: ", document.getElementsByTagName("body")[0].getElementById('map_canvas'));
    // google.maps.event.addDomListener(window, "load", this.showUserMap);
    // this.showUserMap();
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenu = await GlobalService.getMenuData(
        "user",
        this.getUser.token
      );
      await this.findLocation();
      this.$store.commit("global/setLoading", false);
    },
    async findLocation() {
      let userLocation =
        this.userMenu["user.address"].val +
        this.userMenu["user.city"].val +
        this.userMenu["user.country"].val;
      if (userLocation) {
        this.userLatLng = await GlobalService.getUserLocation(userLocation);
        if (this.userLatLng.status === "ZERO_RESULTS") {
          let userCity =
            this.userMenu["user.city"].val + this.userMenu["user.country"].val;
          this.userLatLng = await GlobalService.getUserLocation(userCity);
          if (this.userLatLng.status === "ZERO_RESULTS") {
            let userCountry = this.userMenu["user.country"].val;
            this.userLatLng = await GlobalService.getUserLocation(userCountry);
            if (this.userLatLng.status === "ZERO_RESULTS") {
              this.userLatLng = await GlobalService.getUserLocation("Denmark");
            }
          }
        }
        this.setUserLocation();
      } else {
        router.go(-1);
      }
    },
    setUserLocation() {
      if (this.userLatLng.status === "ZERO_RESULTS") {
      } else {
        let userLoc = {
          lat: this.userLatLng.results[0].geometry.location.lat,
          lng: this.userLatLng.results[0].geometry.location.lng
        };
        this.marker = userLoc;
        this.newPosition = userLoc;
      }
    },
    getDraggedLoc(map) {
      this.newPosition = {
        lat: map.latLng.lat(),
        lng: map.latLng.lng()
      };
    },
    async updateLocation() {
      this.locLoading = true;
      if (this.newPosition.lat && this.newPosition.lng) {
        let updatedLoc = await GlobalService.updateUserLocation(
          this.newPosition.lat,
          this.newPosition.lng,
          this.getUser.token
        );
        if (updatedLoc.status === "0") {
          this.locLoading = false;
          router.push("/");
        } else {
          this.locLoading = false;
          this.openTechDialog("Oops! Something went wrong.");
        }
      } else {
        router.push("/");
      }
    },
    openTechDialog(text) {
      this.msgText = text;
      this.techDialog = true;
    },
    closeTechDialog() {
      this.techDialog = false;
    }
  }
};
</script>
<style>
.google-map {
  width: 800px;
  height: 400px;
  margin: 0 auto;
  background: gray;
}
.md-headline {
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  margin-bottom: 20px;
}
</style>
